module.exports = __webpack_public_path__ + "img/SendButton.cc9cd32f.svg";